import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { GCI140Service } from 'src/app/services/gci140.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { ToastrService } from 'ngx-toastr';
import { updatei140StepStatus, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { I140FileUploadConfiguration } from '../../../../data/models/i140UploadConfiguration';
import { AppServicesLibraryService } from 'app-services-library';

@Component({
  selector: 'app-petitioner-details',
  templateUrl: './petitioner-details.component.html',
  styleUrls: ['./petitioner-details.component.scss']
})
export class PetitionerDetailsComponent implements OnInit {

  fileUploadConfigurations: I140FileUploadConfiguration;
  fileUploadConfigurations1: I140FileUploadConfiguration;

  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  petitionerDetails;

  observableSubscription$ = new Subject();
  inputData: any;
  showNext: boolean = false;
  showPrev: boolean = false;

  constructor(
    private store: Store<any>,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private gcI140Service: GCI140Service,
    public dialogService: DialogService,
    private toastr: ToastrService,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.disabledControls = false;
    this.inputData = this.dynamicDialogConfig.data;
    this.showNext = this.inputData?.showNext; 
    this.showPrev = this.inputData?.showPrev;
  }

  ngOnInit(): void {
    // Selector for step status update
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.getPetitionerDetails();
      this.fileUploadConfigurations = Object.assign({}, {
        disableControls: this.disabledControls,
        isDocumentTypeRequired: false,
        isDocumentUploadRequired: false,
        isViewEnabled: true,
        isDownloadEnabled: true,
        isDeleteEnabled: true,
        getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPGENDOC`,
        postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPGENDOC/fileCategory/`,
        deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
        documentTypeDropdownCode: 'COMPGENDOC'
      });
      this.fileUploadConfigurations1 = Object.assign({}, {
        disableControls: this.disabledControls,
        isDocumentTypeRequired: true,
        isDocumentUploadRequired: true,
        isViewEnabled: true,
        isDownloadEnabled: true,
        isDeleteEnabled: true,
        getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPSPECDOC`,
        postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPSPECDOC/fileCategory/`,
        deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
        documentTypeDropdownCode: 'COMPSPECDOC'
      });
      // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
      //   this.updateStepStatus('INPROGRESS');
      // }
      this.toggleControlsStatus();
    });

  }

  syncPetitionerDocuments() {
    this.gcI140Service.syncDocument(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId,
      this.dynamicDialogConfig.data.i140CaseId, this.fileUploadConfigurations.documentTypeDropdownCode).subscribe((response: ImagilityBaseResponse) => {
        if (response && response.data) {
          this.toastr.success(response.message, 'Success');
          this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
        }
      });
  }

  getPetitionerDetails() {
    this.gcI140Service.getPetitionerDetails(this.dynamicDialogConfig.data.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      this.petitionerDetails = response.data;
    });
  }

  updateStepStatus(status) {
    this.store.dispatch(updatei140StepStatus({ payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status), subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode }));
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    this.fileUploadConfigurations = Object.assign({}, {
      disableControls: this.disabledControls,
      isDocumentTypeRequired: false,
      isDocumentUploadRequired: false,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPGENDOC`,
      postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPGENDOC/fileCategory/`,
      deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
      documentTypeDropdownCode: 'COMPGENDOC'
    });
    this.fileUploadConfigurations1 = Object.assign({}, {
      disableControls: this.disabledControls,
      isDocumentTypeRequired: true,
      isDocumentUploadRequired: true,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      getApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPSPECDOC`,
      postApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/category/COMPSPECDOC/fileCategory/`,
      deleteApiUrl: `/superTask/${this.dynamicDialogConfig.data.superTaskId}/subTask/${this.dynamicDialogConfig.data.subTaskId}/gc/i140Case/${this.dynamicDialogConfig.data.i140CaseId}/document/`,
      documentTypeDropdownCode: 'COMPSPECDOC'
    });
  }

  handleClose() {
    this.dynamicDialogRef.close();
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }

}
